import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useResize } from '../../utils';
import { Button } from '../Button';
import styles from './MarketingBanner.module.scss';
export const MarketingBanner = ({ heading, label, text, imageUrl = null, mobileImageUrl = null, palette = 'primaryBlue', ctaText = null, handleCtaClick = () => { }, gutterBottom = false, }) => {
    const bannerRef = useRef(null);
    const bannerSize = useResize(bannerRef);
    const [padding, setPadding] = useState({ paddingRight: 24, paddingTop: 20 });
    const [imageOnTop, setImageOnTop] = useState(false);
    useEffect(() => {
        if (imageUrl && bannerRef.current) {
            if (bannerSize.width > 600) {
                setPadding({
                    paddingRight: (bannerSize.height > 300 ? 300 : bannerSize.height) + 24,
                    paddingTop: 20,
                });
                setImageOnTop(false);
            }
            else {
                setPadding({ paddingRight: 24, paddingTop: bannerSize.width / 2 + 24 });
                setImageOnTop(true);
            }
        }
    }, [bannerSize, imageUrl]);
    return (<div ref={bannerRef} className={clsx(styles.marketingBanner, styles[palette], gutterBottom && styles.gutterBottom)}>
      <div className={styles.content} style={Object.assign({}, padding)}>
        <h4>{label}</h4>
        <h2>{heading}</h2>
        <p>{text}</p>
        {ctaText && (<Button onClick={handleCtaClick} variant={palette === 'primaryBlue' ? 'outlinedWhite' : 'contained'}>
            {ctaText}
          </Button>)}
      </div>
      {imageUrl && (<div className={clsx(styles.image, imageOnTop && styles.onTop)} style={{
                backgroundImage: `url(${imageOnTop ? mobileImageUrl || imageUrl : imageUrl})`,
            }}/>)}
    </div>);
};
